// Dashboard Events
export const DASHBOARD_EVENTS = {
  // Welcome Component Events
  CREATE_JOB_LINK_CLICKED: "DASHBOARD_CREATE_JOB_LINK_CLICKED",
  MONITOR_JOBS_LINK_CLICKED: "DASHBOARD_MONITOR_JOBS_LINK_CLICKED",
  LAUNCH_NOTEBOOKS_LINK_CLICKED: "DASHBOARD_LAUNCH_NOTEBOOKS_LINK_CLICKED",
  TRAIN_MODELS_LINK_CLICKED: "DASHBOARD_TRAIN_MODELS_LINK_CLICKED",
  VIEW_DOCUMENTATION_LINK_CLICKED: "DASHBOARD_VIEW_DOCUMENTATION_LINK_CLICKED",
  TERMS_OF_USE_LINK_CLICKED: "DASHBOARD_TERMS_OF_USE_LINK_CLICKED",

  // EaiCards Component Events
  JUPYTER_NOTEBOOK_GET_STARTED_CLICKED:
    "DASHBOARD_JUPYTER_NOTEBOOK_GET_STARTED_CLICKED",
  DATA_EXPLORER_GET_STARTED_CLICKED:
    "DASHBOARD_DATA_EXPLORER_GET_STARTED_CLICKED",
  API_DOCS_GET_STARTED_CLICKED: "DASHBOARD_API_DOCS_GET_STARTED_CLICKED",

  // Job Component Events
  RECENT_JOB_CLICKED: "DASHBOARD_RECENT_JOB_CLICKED",
  JOB_ROW_CLICKED: "DASHBOARD_JOB_ROW_CLICKED",
  DATA_ROW_CLICKED: "DASHBOARD_DATA_ROW_CLICKED",

  // Home Component Events
  SEE_ALL_JOBS_CLICKED: "DASHBOARD_SEE_ALL_JOBS_CLICKED",

  // Get Started Panel
  GET_STARTED_PANEL_HIDDEN: "DASHBOARD_GET_STARTED_PANEL_HIDDEN",

  // Filter Chips
  FILTER_CHIP_TOGGLED: "DASHBOARD_FILTER_CHIP_TOGGLED",
} as const;

export const NAVIGATION_EVENTS = {
  SIDE_NAVIGATION_TOGGLE_CLICKED: "NAVIGATION_SIDE_NAVIGATION_TOGGLE_CLICKED",
  SIDE_NAVIGATION_DASHBOARD_CLICKED:
    "NAVIGATION_SIDE_NAVIGATION_DASHBOARD_CLICKED",
  SIDE_NAVIGATION_DATA_EXPLORER_CLICKED:
    "NAVIGATION_SIDE_NAVIGATION_DATA_EXPLORER_CLICKED",
  SIDE_NAVIGATION_NOTEBOOKS_CLICKED:
    "NAVIGATION_SIDE_NAVIGATION_NOTEBOOKS_CLICKED",
  SIDE_NAVIGATION_PERMISSIONS_CLICKED:
    "NAVIGATION_SIDE_NAVIGATION_PERMISSIONS_CLICKED",
  SIDE_NAVIGATION_PERMISSIONS_PERMISSIONS_CLICKED:
    "NAVIGATION_SIDE_NAVIGATION_PERMISSIONS_PERMISSIONS_CLICKED",
  SIDE_NAVIGATION_PERMISSIONS_ACCESS_REQUESTS_CLICKED:
    "NAVIGATION_SIDE_NAVIGATION_PERMISSIONS_ACCESS_REQUESTS_CLICKED",
  SIDE_NAVIGATION_ASSISTANT_CLICKED:
    "NAVIGATION_SIDE_NAVIGATION_ASSISTANT_CLICKED",
  SIDE_NAVIGATION_JOBS_CLICKED: "NAVIGATION_SIDE_NAVIGATION_JOBS_CLICKED",
  SIDE_NAVIGATION_JOBS_JOBS_CLICKED:
    "NAVIGATION_SIDE_NAVIGATION_JOBS_JOBS_CLICKED",
  SIDE_NAVIGATION_JOBS_OVERVIEW_CLICKED:
    "NAVIGATION_SIDE_NAVIGATION_JOBS_OVERVIEW_CLICKED",
  SIDE_NAVIGATION_DOCS_CLICKED: "NAVIGATION_SIDE_NAVIGATION_DOCS_CLICKED",
  TOP_NAVIGATION_AI_TOOLKIT_CLICKED:
    "NAVIGATION_TOP_NAVIGATION_AI_TOOLKIT_CLICKED",
  TOP_NAVIGATION_AVATAR_CLICKED: "NAVIGATION_TOP_NAVIGATION_AVATAR_CLICKED",
  TOP_NAVIGATION_LOGOUT_CLICKED: "NAVIGATION_TOP_NAVIGATION_LOGOUT_CLICKED",
} as const;

export const PAGE_NAMES = {
  DASHBOARD: "DASHBOARD_PAGE_VISITED",
  DATA_EXPLORER: "DATA_EXPLORER_PAGE_VISITED",
  DATA_EXPLORER_DETAILS: "DATA_EXPLORER_DETAILS_PAGE_VISITED",
  NOTEBOOKS: "NOTEBOOKS_PAGE_VISITED",
  NEW_NOTEBOOK: "NEW_NOTEBOOK_PAGE_VISITED",
  JOBS: "JOBS_PAGE_VISITED",
  NEW_JOB: "NEW_JOB_PAGE_VISITED",
  JOB_DETAILS: "JOB_DETAILS_PAGE_VISITED",
  OVERVIEW: "OVERVIEW_PAGE_VISITED",
  ASSISTANT: "ASSISTANT_PAGE_VISITED",
  ACCESS_REQUESTS: "ACCESS_REQUESTS_PAGE_VISITED",
  NEW_ACCESS_REQUEST: "NEW_ACCESS_REQUEST_PAGE_VISITED",
  ACCESS_REQUEST_DETAILS: "ACCESS_REQUEST_DETAILS_PAGE_VISITED",
  PERMISSIONS: "PERMISSIONS_PAGE_VISITED",
  API_DOCS: "API_DOCS_PAGE_VISITED",
  OTHER: "OTHER_PAGE_VISITED",
} as const;

export const ACCESS_REQUEST_EVENTS = {
  // AccessRequestsTable
  STATE_FILTER_CHANGED: "ACCESS_REQUESTS_STATE_FILTER_CHANGED",
  QUICK_FILTER_APPLIED: "ACCESS_REQUESTS_QUICK_FILTER_APPLIED",
  NEW_REQUEST_BUTTON_CLICKED: "ACCESS_REQUESTS_NEW_REQUEST_BUTTON_CLICKED",

  // NewAccessRequestForm
  FORM_SUBMITTED: "ACCESS_REQUESTS_FORM_SUBMITTED",
  FORM_SUBMIT_SUCCEEDED: "ACCESS_REQUESTS_FORM_SUBMIT_SUCCEEDED",
  FORM_SUBMIT_FAILED: "ACCESS_REQUESTS_FORM_SUBMIT_FAILED",
  FORM_CANCELLED: "ACCESS_REQUESTS_FORM_CANCELLED",
  FORM_BACK_CLICKED: "ACCESS_REQUESTS_FORM_BACK_CLICKED",
  FORM_STEP_VIEWED: "ACCESS_REQUESTS_FORM_STEP_VIEWED",

  // AccessRequestDetail
  APPROVE_BUTTON_CLICKED: "ACCESS_REQUESTS_APPROVE_BUTTON_CLICKED",
  APPROVE_CONFIRMED: "ACCESS_REQUESTS_APPROVE_CONFIRMED",
  REJECT_BUTTON_CLICKED: "ACCESS_REQUESTS_REJECT_BUTTON_CLICKED",
  REJECT_CONFIRMED: "ACCESS_REQUESTS_REJECT_CONFIRMED",
  CANCEL_BUTTON_CLICKED: "ACCESS_REQUESTS_CANCEL_BUTTON_CLICKED",
  CANCEL_CONFIRMED: "ACCESS_REQUESTS_CANCEL_CONFIRMED",
} as const;

export const JOBS_EVENTS = {
  // Jobs Monitor (list view)
  LIST_SEARCH_PERFORMED: "JOBS_LIST_SEARCH_PERFORMED",
  LIST_STATE_FILTER_CHANGED: "JOBS_LIST_STATE_FILTER_CHANGED",
  LIST_ACCOUNT_FILTER_CHANGED: "JOBS_LIST_ACCOUNT_FILTER_CHANGED",
  LIST_CREATOR_FILTER_CHANGED: "JOBS_LIST_CREATOR_FILTER_CHANGED",
  LIST_QUICK_FILTER_TOGGLED: "JOBS_LIST_QUICK_FILTER_TOGGLED",
  LIST_ROW_CLICKED: "JOBS_LIST_ROW_CLICKED",
  LIST_CANCEL_CLICKED: "JOBS_LIST_CANCEL_CLICKED",
  LIST_CANCEL_CONFIRMED: "JOBS_LIST_CANCEL_CONFIRMED",
  LIST_RETRY_CLICKED: "JOBS_LIST_RETRY_CLICKED",
  LIST_REQUEST_ACCESS_CLICKED: "JOBS_LIST_REQUEST_ACCESS_CLICKED",
  LIST_CELL_COPIED: "JOBS_LIST_CELL_COPIED",

  // Job Detail view
  DETAIL_TAB_CHANGED: "JOBS_DETAIL_TAB_CHANGED",
  DETAIL_CANCEL_CLICKED: "JOBS_DETAIL_CANCEL_CLICKED",
  DETAIL_RETRY_CLICKED: "JOBS_DETAIL_RETRY_CLICKED",
  DETAIL_WEB_ACCESS_CLICKED: "JOBS_DETAIL_WEB_ACCESS_CLICKED",
  DETAIL_RESOURCE_USAGE_CLICKED: "JOBS_DETAIL_RESOURCE_USAGE_CLICKED",
  DETAIL_USE_AS_TEMPLATE_CLICKED: "JOBS_DETAIL_USE_AS_TEMPLATE_CLICKED",

  // Job Logs
  LOGS_GO_TO_START_CLICKED: "JOBS_LOGS_GO_TO_START_CLICKED",
  LOGS_DOWNLOAD_CLICKED: "JOBS_LOGS_DOWNLOAD_CLICKED",
  LOGS_GO_TO_END_CLICKED: "JOBS_LOGS_GO_TO_END_CLICKED",
  LOGS_FILTER_PERFORMED: "JOBS_LOGS_FILTER_PERFORMED",

  // New Job form
  CREATE_FORM_SUBMITTED: "JOBS_CREATE_FORM_SUBMITTED",
  CREATE_FORM_SUCCEEDED: "JOBS_CREATE_FORM_SUCCEEDED",
  CREATE_FORM_FAILED: "JOBS_CREATE_FORM_FAILED",
  CREATE_FORM_BACK_CLICKED: "JOBS_CREATE_FORM_BACK_CLICKED",
} as const;

export const NOTEBOOKS_EVENTS = {
  // Notebooks list
  NEW_NOTEBOOK_BUTTON_CLICKED: "NOTEBOOKS_NEW_NOTEBOOK_BUTTON_CLICKED",
  NOTEBOOK_RESTART_CLICKED: "NOTEBOOKS_NOTEBOOK_RESTART_CLICKED",
  NOTEBOOK_OPEN_CLICKED: "NOTEBOOKS_NOTEBOOK_OPEN_CLICKED",

  // New Notebook form
  CREATE_FORM_SUBMITTED: "NOTEBOOKS_CREATE_FORM_SUBMITTED",
  CREATE_FORM_SUCCEEDED: "NOTEBOOKS_CREATE_FORM_SUCCEEDED",
  CREATE_FORM_FAILED: "NOTEBOOKS_CREATE_FORM_FAILED",
  CREATE_FORM_BACK_CLICKED: "NOTEBOOKS_CREATE_FORM_BACK_CLICKED",
} as const;

export const DATA_EXPLORER_EVENTS = {
  // List view
  LIST_SEARCH_PERFORMED: "DATA_EXPLORER_LIST_SEARCH_PERFORMED",
  LIST_CREATOR_FILTER_CHANGED: "DATA_EXPLORER_LIST_CREATOR_FILTER_CHANGED",
  LIST_QUICK_FILTER_TOGGLED: "DATA_EXPLORER_LIST_QUICK_FILTER_TOGGLED",
  LIST_DATE_FILTER_CHANGED: "DATA_EXPLORER_LIST_DATE_FILTER_CHANGED",
  LIST_ROW_CLICKED: "DATA_EXPLORER_LIST_ROW_CLICKED",
  LIST_REQUEST_ACCESS_CLICKED: "DATA_EXPLORER_LIST_REQUEST_ACCESS_CLICKED",
  LIST_CELL_COPIED: "DATA_EXPLORER_LIST_CELL_COPIED",
  LIST_METADATA_FALLBACK_SHOWN: "DATA_EXPLORER_LIST_METADATA_FALLBACK_SHOWN",
  LIST_METADATA_ROW_CLICKED: "DATA_EXPLORER_LIST_METADATA_ROW_CLICKED",
  LIST_EDIT_CLASSIFICATION_CLICKED:
    "DATA_EXPLORER_LIST_EDIT_CLASSIFICATION_CLICKED",

  // Detail / file browser
  DETAIL_BACK_CLICKED: "DATA_EXPLORER_DETAIL_BACK_CLICKED",
  DETAIL_FILE_NAVIGATED: "DATA_EXPLORER_DETAIL_FILE_NAVIGATED",
} as const;

export const ASSISTANT_EVENTS = {
  MESSAGE_SENT: "ASSISTANT_MESSAGE_SENT",
  NEW_CONVERSATION_STARTED: "ASSISTANT_NEW_CONVERSATION_STARTED",
  RESPONSE_RETRIED: "ASSISTANT_RESPONSE_RETRIED",
  CODE_COPIED: "ASSISTANT_CODE_COPIED",
  FLOATING_BUBBLE_OPENED: "ASSISTANT_FLOATING_BUBBLE_OPENED",
  FLOATING_WINDOW_MINIMIZED: "ASSISTANT_FLOATING_WINDOW_MINIMIZED",
  FLOATING_WINDOW_MAXIMIZED: "ASSISTANT_FLOATING_WINDOW_MAXIMIZED",
} as const;
